import React from "react";
import { isElement } from "../../../shared/helpers/reactHelpers";
import "./trustIconList.scss";

interface Icon {
  alt: string;
  img: string;
}

interface Props {
  title: string;
  iconList: (Icon | JSX.Element)[];
  className: string;
}

const TrustIconList = ({ title, iconList, className }: Props): JSX.Element => {
  const logoPath = "/images/logos";
  return (
    <div className={`trust-icon-list ${className}`}>
      <h3 className="heading--3 text--mid">{title}</h3>
      <div className="trust-icons">
        {
          iconList.map((icon, index) => {
            if (isElement(icon)) {
              return (
                <div className="trust-icon" key={index}>
                  {icon}
                </div>
              );
            }
            else {
              return (
                <div className="trust-icon" key={index}>
                  <img
                    className="lazyload"
                    data-src={icon.img.startsWith("/") ? icon.img : `${logoPath}/${icon.img}`}
                    alt={icon.alt}
                  />
                </div>
              );
            }
          })
        }
      </div>
    </div>);
};

export default TrustIconList;
